module.exports = __webpack_public_path__ + "03_glasses_red.af13053a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/03_glasses_red.png
// module id = r9SO
// module chunks = 0